var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrill = function SvgGrill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.25 6.667a1.25 1.25 0 1 0-2.5 0v1.666a1.25 1.25 0 1 0 2.5 0V6.666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.333 12.084a1.25 1.25 0 0 0-1.25 1.25A11.25 11.25 0 0 0 13.52 23.5l-2.96 5.918-.022.046-1.655 3.31a1.25 1.25 0 1 0 2.236 1.117l1.321-2.642h11.485a4.583 4.583 0 1 0 3.555-5.753l-.996-1.993a11.246 11.246 0 0 0 6.434-9.796v-.374c0-.69-.56-1.25-1.25-1.25H8.333Zm15.59 16.666H13.69l2.216-4.432c.791.175 1.605.265 2.428.265h3.333c.823.001 1.638-.089 2.43-.263l1.147 2.295a4.582 4.582 0 0 0-1.32 2.135ZM26.25 30v.005a2.084 2.084 0 1 0 0-.01V30ZM12.146 19.52a8.75 8.75 0 0 1-2.473-4.936h20.661a8.75 8.75 0 0 1-8.666 7.5h-3.335a8.75 8.75 0 0 1-6.187-2.563Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 5.417c.69 0 1.25.56 1.25 1.25v1.666a1.25 1.25 0 1 1-2.5 0V6.666c0-.69.56-1.25 1.25-1.25ZM16.25 6.667a1.25 1.25 0 1 0-2.5 0v1.666a1.25 1.25 0 1 0 2.5 0V6.666Z"
  })));
};
export default SvgGrill;